import { render } from "./calcel-btn.vue?vue&type=template&id=a4ce7622"
import script from "./calcel-btn.vue?vue&type=script&lang=js"
export * from "./calcel-btn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__